export default __webpack_public_path__ + "static/unperfectring-277b5302b3f4e300061cba6dd26f9cee.png";